module.exports = __webpack_public_path__ + "static/media/tharakaLogo.890c1015.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tharakaLogo.png
// module id = 100
// module chunks = 0